import React from 'react';
import ElectoralLiteracy2023 from 'views/ElectoralLiteracy2023';

const LifeSkillPage = () => {
  return <ElectoralLiteracy2023/>;
};

export default LifeSkillPage;